import { Component} from '@angular/core';
import { OwlOptions } from 'ngx-owl-carousel-o';

// 1. Interface for Fun Facts
export interface FactItem {
  value: string;
  label: string;
  delay: string;
}

// 2. Interface for Team Members
export interface TeamMember {
  id: string;
  name: string;
  designation: string;
  image: string;
  facebook?: string;
  twitter?: string;
  instagram?: string;
  linkedin?: string;
}

@Component({
  standalone: false,
  selector: 'app-our-team',
  templateUrl: './our-team.component.html',
  styleUrl: './our-team.component.css'
})
export class OurTeamComponent {
  // Fun Facts Data Array
  facts: FactItem[] = [
    {
      value: '99',
      label: 'Success in getting happy customer',
      delay: '.1s'
    },
    {
      value: '25',
      label: 'Thousands of successful business',
      delay: '.3s'
    },
    {
      value: '120',
      label: 'Total clients who love HighTech',
      delay: '.5s'
    },
    {
      value: '5',
      label: 'Stars reviews given by satisfied clients',
      delay: '.7s'
    }
  ];

  // Lifecycle Hooks
  ngOnInit(): void {
    // Initialization code (if any)
  }

  ngOnDestroy(): void {
    // Cleanup code (if any)
  }

  // Responsive Owl Carousel Options for Team Slider
  customOptionsTwo: OwlOptions = {
    loop: true,
    mouseDrag: true,
    touchDrag: true,
    pullDrag: false,
    dots: false,
    margin: 25,
    navSpeed: 700,
    navText: ['<i class="fa fa-angle-left"></i>', '<i class="fa fa-angle-right"></i>'],
    responsive: {
      0: {
        items: 1
      },
      576: {
        items: 3
      },
      768: {
        items: 3
      },
      992: {
        items: 3
      }
    },
    nav: true
  };


  // Dynamic Team Members Array
  teamStore: TeamMember[] = [
    {
      id: 'team-1',
      name: 'Eric Cantona',
      designation: 'CEO / Founder',
      image: 'assets/images/team-1.jpg',
      facebook: '#.',
      twitter: '#.',
      instagram: '#.',
      linkedin: '#.'
    },
    {
      id: 'team-2',
      name: 'Sofia Doe',
      designation: 'Project Manager',
      image: 'assets/images/team-2.jpg',
      facebook: '#.',
      twitter: '#.',
      instagram: '#.',
      linkedin: '#.'
    },
    {
      id: 'team-3',
      name: 'Alex Jeff',
      designation: 'UI/UX Designer',
      image: 'assets/images/team-3.jpg',
      facebook: '#.',
      twitter: '#.',
      instagram: '#.',
      linkedin: '#.'
    },
    {
      id: 'team-4',
      name: 'Morris Jeff',
      designation: 'Web Developer',
      image: 'assets/images/team-4.jpg',
      facebook: '#.',
      twitter: '#.',
      instagram: '#.',
      linkedin: '#.'
    }
  ];
}
